import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Drawer } from "@mui/material";
import { CreateElectionEventScreen } from "./CreateScreen";
import { useCreateElectionEventStore } from "@/providers/CreateElectionEventContextProvider";
export var CreateDataDrawer = function (_a) {
    var open = _a.open, closeDrawer = _a.closeDrawer;
    var _b = useCreateElectionEventStore(), createDrawer = _b.createDrawer, closeCreateDrawer = _b.closeCreateDrawer;
    return (_jsx(_Fragment, { children: _jsx(Drawer, { anchor: "right", open: createDrawer, onClose: closeCreateDrawer, PaperProps: {
                sx: { width: "30%" },
            }, children: _jsx(CreateElectionEventScreen, {}) }) }));
};
